import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { ContractGroupTypeActions, ContractGroupTypeActionTypes } from '../../actions/mdqx/contract-group-type.actions';
import { ContractGroupTypeEntity } from '../../../entities/mdqx/contract-group-type.entity';

export interface ContractGroupTypeState extends EntityState<ContractGroupTypeEntity> {
    fetched: boolean;
}

export const CONTRACTGROUPTYPE_KEY = 'contractGroupType';

const adapter = createEntityAdapter<ContractGroupTypeEntity>({
    selectId: contractGroupType => contractGroupType.Id,
});

const initialState: ContractGroupTypeState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function contractGroupTypeReducer(state = initialState, action: ContractGroupTypeActions) {
    switch (action.type) {
        case ContractGroupTypeActionTypes.GetContractGroupTypeResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllContractGroupType = selectAll;

export const selectContractGroupTypeFetched = (state: ContractGroupTypeState) => state.fetched;
